function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from "react";
import { Form } from "react-bootstrap";
import PropTypes from "prop-types";
import DatePicker from "react-datepicker";
import _ from "lodash";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";

var ButtonInput = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ButtonInput, _React$Component);

  function ButtonInput() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "handleClick", function (e) {
      e.preventDefault();

      _this.props.onClick(e);
    });

    return _this;
  }

  var _proto = ButtonInput.prototype;

  _proto.render = function render() {
    var value = this.props.value;
    if (value && this.props.displayFormat) value = moment(this.props.value).format(this.props.displayFormat);
    return /*#__PURE__*/React.createElement("a", {
      className: "btn btn-sm btn-secondary",
      href: "#!",
      onClick: this.handleClick
    }, value || /*#__PURE__*/React.createElement("span", {
      className: "d-print-none"
    }, "Choose Date"));
  };

  return ButtonInput;
}(React.Component);

ButtonInput.propTypes = process.env.NODE_ENV !== "production" ? {
  onClick: PropTypes.func,
  value: PropTypes.string
} : {};

var ReactDatePickerWidget = /*#__PURE__*/function (_Component) {
  _inheritsLoose(ReactDatePickerWidget, _Component);

  function ReactDatePickerWidget(props) {
    var _this2;

    _this2 = _Component.call(this, props) || this;
    _this2.state = _extends({}, props);
    _this2.dataFormat = null;
    _this2.displayFormat = "MM/DD/YYYY";

    if (_this2.state.options && _this2.state.options.format) {
      if (typeof _this2.state.options.format === "object" && _this2.state.options.format !== null) {
        _this2.dataFormat = _this2.state.options.format.data;
        _this2.displayFormat = _this2.state.options.format.display;
      } else {
        _this2.dataFormat = _this2.state.options.format;
        _this2.displayFormat = _this2.state.options.format;
      }
    }

    return _this2;
  }

  var _proto2 = ReactDatePickerWidget.prototype;

  _proto2.render = function render() {
    var _this3 = this;

    var _$get = _.get(this.props, "schema", {}),
        title = _$get.title;

    var selected = null;
    if (this.state.value) selected = moment(this.state.value, this.dataFormat).toDate();
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Form.Label, null, title), /*#__PURE__*/React.createElement("div", {
      style: {
        display: "block"
      }
    }, /*#__PURE__*/React.createElement(DatePicker, {
      customInput: /*#__PURE__*/React.createElement(ButtonInput, {
        displayFormat: this.displayFormat
      }),
      selected: selected,
      required: this.state.required,
      onChange: function onChange(date) {
        var value = date;
        if (_this3.dataFormat) value = moment(date).format(_this3.dataFormat);

        _this3.setState({
          value: date
        }, function () {
          return _this3.state.onChange(value);
        });
      },
      strictParsing: true,
      disabled: this.state.disabled,
      readOnly: this.state.readonly,
      isClearable: true
    }), /*#__PURE__*/React.createElement("input", {
      name: this.props.id,
      id: this.props.id,
      style: {
        position: "absolute",
        border: 0,
        width: 1,
        height: 1
      },
      type: "text",
      onChange: function onChange(event) {
        return _this3.state.value;
      },
      required: this.props.required,
      value: this.state.value || ""
    })));
  };

  return ReactDatePickerWidget;
}(Component);

export default ReactDatePickerWidget;